import React from 'react';
import { Box, IconWrapperProps, Text, useResponsive } from '@common-fe/common-fe';

import theme from '@/styles/theme';

interface BlockWrapperProps {
  id?: string;
  Icon: IconWrapperProps;
  title: string;
  children: React.ReactNode;
}

const BlockWrapper: React.FC<BlockWrapperProps> = ({ id, Icon, title, children }) => {
  const { isMobile } = useResponsive();
  return (
    <Box id={id} pad={{ top: isMobile ? 'spacing24' : 'spacing48' }}>
      <Box direction="row" align="center" pad={isMobile ? { horizontal: 'spacing16' } : {}}>
        <Box
          justify="center"
          align="center"
          width="40px"
          height="40px"
          round="full"
          background="iconAccent"
          margin={isMobile ? { right: 'spacing12' } : { right: 'spacing16', bottom: 'spacing4' }}
        >
          <Icon color={theme.colors.iconOnColor} />
        </Box>
        <Text size={isMobile ? 'xl' : '2xl'} weight={700}>
          {title}
        </Text>
      </Box>
      <Box style={{ position: 'relative' }} margin={{ top: 'spacing16' }}>
        <Box background="module" round="moduleRound" pad="spacing24" style={{ zIndex: 10 }}>
          {children}
        </Box>
        {/* <IconWrapper>
        <Icon size={BIG_ICON_SIZE} color={theme.colors.module} />
      </IconWrapper> */}
      </Box>
    </Box>
  );
};

export default BlockWrapper;
